import _ from 'lodash';
import M from 'moment';
import * as VueGoogleMaps from 'vue2-google-maps';
// import Notifications from 'vue-notification';
// import Vue2TouchEvents from 'vue2-touch-events'
import { Pagination } from 'bootstrap-vue/es/components';

import bootstrapdatetimepicker from 'bootstrap-datetimepicker-npm';

import getHelpers from './helpers';

const libs = {};
window.exportLib = (key, value) => {
    libs[key] = value;
}

window.importLib = (key) => {
    return libs[key];
}

// Vue.use(Notifications);
// Vue.use(Vue2TouchEvents);
Vue.use(Pagination);
Vue.use(VueGoogleMaps, {
    load: {
        key: window.env.GOOGLE_MAP_KEY,
        libraries: "places" // necessary for places input
    }
});

window.mountVueComponent = (id, component) => {
    var root = document.getElementById(id);
    if (root) {
        var data = null;
        var config = null;

        try {
            var content = root.textContent;
            content = JSON.parse(content);
            data = content.data || null;
            config = content.config || null;

        } catch (e) {
            console.info(`Problem parsing data and config for component ${id}`);
        }

        new Vue({
            el: root,
            render: h => h(component, {
                props: { initialData: data, config }
            }),
        })
    }
}

window.exportLib('lodash', _);
window.exportLib('moment', M);
window.exportLib('getHelpers', getHelpers);

_.chain(document.querySelectorAll('script[data-src]'))
    .map((el) => {
        el.src = el.getAttribute('data-src');
    })
    .value();

window.dispatchEvent(new CustomEvent('vue-init'));



// WEBPACK FOOTER //
// ./resources/assets/site/js/vue-init.js